<template>
  <div style="width: 90%; color: white; display: flex; flex-direction: column;">
    <div id="header">设备状态百分比</div>
    <div id="rightOne2Content" >
      <el-row>
        <el-col :span="2">
          <p class="beforeItems" style="margin-top: 1.5em;">
            警 报 设 备
          </p>
        </el-col>
        <el-col :span="11">
          <div  class="divItem" >
            <div >供电</div>
            <div>{{CENum}}%</div>
            <svg viewBox="0 0 100 100">
              <path id="RightTopPre"
                    d="M 50 40 m -35 0 a 35 35 0 1 0 70 0  a 35 35 0 1 0 -70 0"
                    fill="none"
                    stroke="#6f7691"
                    stroke-width="8">
                ></path>
              <path id="RightTop"
                    d="M 50 40 m -35 0 a 35 35 0 1 0 70 0  a 35 35 0 1 0 -70 0"
                    fill="none"
                    stroke="#1ca9e9"
                    stroke-linecap="round"
                    transform="rotate(90,50,40)"
                    stroke-width="8">
              </path>
            </svg>
          </div>
        </el-col>
        <el-col :span="11">
          <div  class="divItem" >
            <div >开机</div>
            <div>{{onNum}}%</div>
            <svg viewBox="0 0 100 100">
              <path id="leftBottomPre"
                    d="M 50 40 m -35 0 a 35 35 0 1 0 70 0  a 35 35 0 1 0 -70 0"
                    fill="none"
                    stroke="#6f7691"
                    stroke-width="8">
                ></path>
              <path id="leftBottom"
                    d="M 50 40 m -35 0 a 35 35 0 1 0 70 0  a 35 35 0 1 0 -70 0"
                    fill="none"
                    stroke="#26c1c9"
                    stroke-linecap="round"
                    transform="rotate(90,50,40)"
                    stroke-width="8">
              </path>
            </svg>
          </div>
        </el-col>
      </el-row>
      <div style="margin-top: -30px; height: 2px; width: 100%; background-color: #505465; "></div>
      <el-row style="top: -20px;">
        <el-col :span="2">
          <p class="beforeItems" style="margin-top: 1.5em;">
            监 测 终 端
          </p>
        </el-col>
        <el-col :span="11">
          <div class="divItem" >
            <div >在线</div>
            <div>{{onlineNum}}%</div>
            <svg viewBox="0 0 100 100">
              <path id="leftTopPre"
                    d="M 50 40 m -35 0 a 35 35 0 1 0 70 0  a 35 35 0 1 0 -70 0"
                    fill="none"
                    stroke="#6f7691"
                    stroke-width="8">
                ></path>
              <path id="leftTop"
                    d="M 50 40 m -35 0 a 35 35 0 1 0 70 0  a 35 35 0 1 0 -70 0"
                    fill="none"
                    stroke="#6658cb"
                    stroke-linecap="round"
                    transform="rotate(90,50,40)"
                    stroke-width="8">
              </path>
            </svg>
          </div>
        </el-col>
        <el-col :span="11">
          <div  class="divItem" >
            <div >分贝过高</div>
            <div>{{alarmNum}}%</div>
            <svg viewBox="0 0 100 100">
              <path id="RightBottomPre"
                    d="M 50 40 m -35 0 a 35 35 0 1 0 70 0  a 35 35 0 1 0 -70 0"
                    fill="none"
                    stroke="#6f7691"
                    stroke-width="8">
                ></path>
              <path id="RightBottom"
                    d="M 50 40 m -35 0 a 35 35 0 1 0 70 0  a 35 35 0 1 0 -70 0"
                    fill="none"
                    stroke="#0154c8"
                    stroke-linecap="round"
                    transform="rotate(90,50,40)"
                    stroke-width="8">
              </path>
            </svg>
          </div>
        </el-col>


      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HomeRightOne2',
  props:['areaId'],
  data(){
    return {
      isLoading: true,
      AreaDevScreen:{
        "version": 1,
        "method": "synthScreen.AreaDevScreen",
        "params": {
          "areaId":"0",
        },
        "token": "",
        "id": 0
      },

      CENum: 0, // 市电供电数
      alarmNum: 0, // 告警数
      devNum: 0, // 设备总数
      onNum: 0, // 开机数
      onlineNum: 0, //在线数

      interval:null, // 轮询

    }
  },
  methods: {
    getAreaDevScreen(init){
      if(init){
        // 是主页第一次刷新，要切换显示和隐藏
        this.isLoading = true;
      }
      this.AreaDevScreen.token = this.$store.state.token;
      this.AreaDevScreen.params.areaId = this.areaId;
      this.$axios.post(this.$newMainUrl, this.AreaDevScreen).then(res=> {
        // this.$message({
        //   type: 'success',
        //   message: '刷新'
        // })
        this.isLoading = false;
        if(res.data.hasOwnProperty('result')){
          if(this.AreaDevScreen.params.areaId.length==1){
            this.CENum = res.data.result.CENumAll;
            this.alarmNum = res.data.result.alarmNumAll;
            this.devNum = res.data.result.devNumAll;
            this.onNum = res.data.result.onNumAll;
            this.onlineNum = res.data.result.onlineAll;
          }
          if(this.AreaDevScreen.params.areaId.length==2){
            this.CENum = res.data.result.CENumAll;
            this.alarmNum = res.data.result.alarmNumAll;
            this.devNum = res.data.result.devNumAll;
            this.onNum = res.data.result.onNumAll;
            this.onlineNum = res.data.result.onlineNumAll;
          }


          // 如果DevNum是0的话，让其整体为0，否则除下来不是数
          if(this.devNum === 0){
            this.devNum = 1;
          }

          this.CENum = this.devNum === 0 ? 0 : this.CENum * 100 / this.devNum;
          this.alarmNum = this.devNum === 0 ? 0 : this.alarmNum * 100 / this.devNum;
          this.onNum = this.devNum === 0 ? 0 : this.onNum * 100 / this.devNum;
          this.onlineNum = this.devNum === 0 ? 0 : this.onlineNum * 100 / this.devNum;

          this.CENum = Number(this.CENum).toFixed(1);
          this.onlineNum = Number(this.onlineNum).toFixed(1);
          this.onNum = Number(this.onNum).toFixed(1);
          this.alarmNum = Number(this.alarmNum).toFixed(1);

          this.setValue('leftTop', this.onlineNum);
          this.setValue('RightTop', this.CENum);
          this.setValue('leftBottom', this.onNum);
          this.setValue('RightBottom', this.alarmNum);
        }else{
          this.$message({
            type:'error',
            message:'获取设备状态百分比失败，' + res.data.error.message
          })
        }
      })
    },
    setValue(elementId, value){
      var leftTop = document.getElementById(elementId);
      var percent = value/100;
      var radius = 35;
      leftTop.setAttribute('stroke-dasharray', percent * ( 2 * Math.PI * radius) + "," + (1 - percent) * ( 2 * Math.PI * radius));
    }
  },
  mounted(){
    this.getAreaDevScreen();

    this.interval = setInterval(()=>{
      this.getAreaDevScreen();
    }, 3000);

  },
  destroyed(){
    // this.$message({
    //   type: 'error',
    //   message: '结束'
    // })
    clearInterval(this.interval);
  }
}
</script>

<style scoped lang="scss">
  .divItem{
    position: relative;
    text-align: center;
    div:nth-child(1){
      position: absolute; left: 50%; margin-left: -50px; top: 45px; width: 100px; height: 40px;
    }
    div:nth-child(2){
      position: absolute; left: 50%; margin-left: -50px; top: 75px;width: 100px; height: 40px
    }
  }
  #header{
    color: white;
    font-size: 18px;
    font-family: 黑体;
    font-weight: bold;
    margin-left: 0px;
    margin-top: 30px;
  }
  #rightOne2Content{
    margin-top: 20px;
    width: 100%;
    height: 300px;
    /*display: flex;*/
    /*flex-direction: column;*/
    /*flex-wrap: nowrap;*/
    /*.rightItemRow{*/
    /*display: flex;*/
    /*flex-direction: row;*/
    /*flex-wrap: nowrap;*/
    /*.divItem{*/
    /*flex: 1;*/
    /*}*/
    /*}*/
    /*display: grid;*/
    /*grid-template-columns: repeat(2, 50%);*/
    /*grid-template-rows: repeat(2, 50%);*/
  }
  #leftTop{
    /*transform: rotate(10deg 50 50);*/
  }
  .beforeItems{
    -webkit-writing-mode:vertical-rl;
    -moz-writing-mode: vertical-rl;
    -ms-writing-mode: tb-rl;
    writing-mode: vertical-rl;
  }
</style>
